<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add {{ platform.name }} Integration</p>
      </header>
      <section class="modal-card-body">
        <div class="has-text-centered">
          <img :src="platform.logo_url" width="180" height="60" />
        </div>
        <b-field label="fabric Account" >
          <b-input required v-model="accountString" size="is-medium"></b-input>
        </b-field>
        <b-field label="Location Number" >
          <b-input placeholder="(Optional)" v-model="locationNumber" size="is-medium"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$emit('canceled')">Back</button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="!ready || saving"
        >Add Integration</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/platform-accounts/'
    },
    json () {
      const credentials = [{
        credential: { code: 'fabric_account' },
        value: this.accountString
      }]
      if (this.locationNumber !== null) {
        credentials.push({
          credential: { code: 'location_num' },
          value: this.locationNumber
        })
      }
      return {
        platform: { code: this.platform.code },
        credentials: credentials
      }
    },
    ready () {
      return this.accountString
    }
  },
  data () {
    return {
      accountString: null,
      locationNumber: null,
      saving: false,
      errors: {}
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http.post(this.endpoint, this.json).then(response => {
        this.$emit('account:saved')
      }).catch(error => {
        if (error.response && error.response.status === 400) {
          this.errors = { detail: 'Please review your input and try again.' }
        }
      }).finally(() => {
        this.saving = false
      })
    }
  },
  props: ['platform']
}
</script>
